import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  minutas: {}
}

export const getters = {}

export const mutations = {
  MINUTA(state, request) {
    state.cached = request
  }
}

export const actions = {

  init({ state, dispatch }) {},

  createMinutaAccionTutela(context,payload){
    const promise =  axios.post(`${serverUrl}/minutas/generate_minuta_accion_tutela/`, payload, payload.type)
    // const promise =  axios.post(`${serverUrl}/minutas/${payload.foro_id}/save_file/`, payload.formData,{headers: {'Content-Type': 'multipart/form-data'}})
    return promise
  },
  createMinutaDerechoPeticion(context,payload){
    const promise =  axios.post(`${serverUrl}/minutas/generate_minuta_derecho_peticion/`, payload, payload.type)
    // const promise =  axios.post(`${serverUrl}/minutas/${payload.foro_id}/save_file/`, payload.formData,{headers: {'Content-Type': 'multipart/form-data'}})
    return promise
  },
  createMinutaSolicitudCertificado(context,payload){
    const promise =  axios.post(`${serverUrl}/minutas/generate_minuta_solicitud_certificacion/`, payload, payload.type)
    // const promise =  axios.post(`${serverUrl}/minutas/${payload.foro_id}/save_file/`, payload.formData,{headers: {'Content-Type': 'multipart/form-data'}})
    return promise
  },
  createMinutaPresentacionPersoneria(context,payload){
    const promise =  axios.post(`${serverUrl}/minutas/generate_minuta_presentacion_personeria/`, payload, payload.type)
    // const promise =  axios.post(`${serverUrl}/minutas/${payload.foro_id}/save_file/`, payload.formData,{headers: {'Content-Type': 'multipart/form-data'}})
    return promise
  },
  createMinutaActaConstitucion(context,payload){
    const promise =  axios.post(`${serverUrl}/minutas/generate_minuta_acta_constitucion/`, payload, payload.type)
    // const promise =  axios.post(`${serverUrl}/minutas/${payload.foro_id}/save_file/`, payload.formData,{headers: {'Content-Type': 'multipart/form-data'}})
    return promise
  },

}
